import { APICallV3Get } from 'reactApp/api/APICall';

export class GiftListAPICall extends APICallV3Get {
    _method = 'billing/gift/list';
}
